import React, {Component, useState} from 'react'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import {DatePicker} from '@material-ui/pickers'
import moment from 'moment'

export default function Membership(props) {
  console.info('SHOWING MEMBERSHIP')
  const {user, membership} = props
  const start =
    membership && membership.start
      ? new Date(membership.start.seconds * 1000)
      : new Date()
  const end =
    membership && membership.end
      ? new Date(membership.end.seconds * 1000)
      : new Date()

  const [startDate, handleStartDateChange] = useState(moment(start))
  const [endDate, handleEndDateChange] = useState(moment(end))
  const [amount, setAmount] = useState((membership && membership.amount) || 0)
  // useEffect(()=>{

  // }, props.membership)

  // const classes = useStyles()
  const onSave = async () => {
    let updatedMembership = {
      amount: amount,
      userId: user.uid,
      start: startDate.toDate(),
      end: endDate.toDate(),
    }
    if (membership && membership.key) {
      // window.Raven.captureMessage('Updating membership', {
      //   level: 'info',
      //   extra: updatedMembership,
      // })
      await window.firebaseDb
        .collection('memberships')
        .doc(membership.key)
        .set(updatedMembership)
    } else {
      // window.Raven.captureMessage('New membership', {
      //   level: 'info',
      //   extra: updatedMembership,
      // })
      await window.firebaseDb.collection('memberships').add(updatedMembership)
    }
  }

  const onDelete = async () => {
    if (membership && membership.key) {
      await window.firebaseDb
        .collection('memberships')
        .doc(membership.key)
        .delete()
    }
  }

  const handleAmountChange = event => {
    setAmount(event.target.value)
  }

  return (
    <Grid container>
      <Typography className="black">{user.displayName}</Typography>
      <Grid item xs={12}>
        <TextField label="Amount" value={amount} onChange={handleAmountChange}>
          {amount}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={handleStartDateChange}
          format="dd/MM/yyyy"
        />
      </Grid>
      <Grid item xs={12}>
        <DatePicker
          label="End Date"
          value={endDate}
          onChange={handleEndDateChange}
          format="dd/MM/yyyy"
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          onClick={() => {
            handleEndDateChange(moment(startDate).add(1, 'years'))
            setAmount(200)
          }}>
          One Year
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          onClick={() => {
            handleEndDateChange(moment(startDate).add(6, 'months'))
            setAmount(120)
          }}>
          6 Months
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          onClick={() => {
            handleEndDateChange(moment(endDate).add(2, 'months'))
          }}>
          Extend 2 months
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button onClick={onSave}>Save</Button>
        <Button
          onClick={() => {
            props.setOpen(false)
          }}>
          Cancel
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button onClick={onDelete}>Delete</Button>
       
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/users/Membership.js